import React from "react";
import {Box, Divider, Stack, Tooltip, Typography} from "@mui/material";
import {HelpOutline} from "@mui/icons-material";


const FormulaInputHelpTooltip = ({inputProps}) => {

    return (
        <>
            <Tooltip
                slotProps={{
                    tooltip: {
                        sx: {maxWidth: 500, minWidth: 'min(450px, 90vw)', p: 0},
                    },
                }}
                title={
                    <Box sx={{borderRadius: 1, maxHeight: 400, overflow: 'auto', position: 'relative'}}>
                        <Stack direction={'column'} spacing={1} sx={{padding: 2}}>
                            <Stack direction={'column'} spacing={1} sx={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: theme => `rgba(${theme.vars?.palette?.Tooltip?.bg?.replace("rgba(", "rgba(").replace("0.92)", "") ?? '25, 25, 25'}, 1)`,
                                backdropFilter: 'blur(10px)',
                                zIndex: 1,
                                pb: 1,
                                mb: 1
                            }}>
                                <Typography variant={'subtitle1'} fontWeight={700}>Formula Guide</Typography>
                                <Typography variant="body2" sx={{opacity: 0.8}}>
                                    Create dynamic prices using references to other levels and mathematical functions.
                                </Typography>
                                <Divider/>
                            </Stack>

                            <Typography variant={'body2'} fontWeight={600} sx={{mt: 1}}>
                                Dynamic References
                            </Typography>
                            <Typography variant="caption" sx={{opacity: 0.8, mb: 1, display: 'block'}}>
                                Reference other levels using the <Box component="span" sx={{
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                px: 0.6,
                                py: 0.2,
                                borderRadius: 1,
                                border: '1px solid',
                            }}>[Pn]</Box> syntax, or use product costs.
                            </Typography>

                            <table style={{width: '100%', borderCollapse: 'collapse', marginBottom: '12px'}}>
                                <tbody>
                                <tr>
                                    <td style={{width: '90px', paddingBlock: '4px'}}>
                                        <Typography variant="caption" sx={{fontFamily: 'monospace', fontWeight: 700, px: 0.8, py: 0.2, borderRadius: 0.5}}>
                                            [Cost]
                                        </Typography>
                                    </td>
                                    <td style={{paddingBlock: '4px'}}><Typography variant="caption" sx={{opacity: 0.9, fontWeight: 500}}>Current Cost</Typography></td>
                                </tr>
                                <tr>
                                    <td style={{width: '90px', paddingBlock: '4px'}}>
                                        <Typography variant="caption" sx={{fontFamily: 'monospace', fontWeight: 700, px: 0.8, py: 0.2, borderRadius: 0.5}}>
                                            [Avg Cost]
                                        </Typography>
                                    </td>
                                    <td style={{paddingBlock: '4px'}}><Typography variant="caption" sx={{opacity: 0.9, fontWeight: 500}}>Average Cost</Typography></td>
                                </tr>
                                {inputProps.priceLevels?.slice(0, 5).map((pl, i) => (
                                    <tr key={pl.id}>
                                        <td style={{width: '60px', paddingBlock: '4px'}}>
                                            <Typography variant="caption" sx={{
                                                fontFamily: 'monospace',
                                                fontWeight: 700,
                                                px: 0.8,
                                                py: 0.2,
                                                borderRadius: 0.5
                                            }}>
                                                {`[P${i + 1}]`}
                                            </Typography>
                                        </td>
                                        <td style={{paddingBlock: '4px'}}><Typography variant="caption" sx={{opacity: 0.9, fontWeight: 500}}>{pl.title}</Typography></td>
                                    </tr>
                                ))}
                                {inputProps.priceLevels?.length > 5 && (
                                    <tr>
                                        <td colSpan={2}><Typography variant="caption" sx={{opacity: 0.5, fontStyle: 'italic'}}>... and {inputProps.priceLevels.length - 5} more levels</Typography></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>

                            <Divider sx={{opacity: 0.3}}/>

                            <Typography variant={'body2'} fontWeight={600} sx={{mt: 1}}>
                                Operations & Functions
                            </Typography>
                            <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '8px'}}>
                                <thead>
                                <tr>
                                    <th align="left" style={{paddingBottom: '8px'}}><Typography variant="caption" fontWeight={700}>Feature</Typography></th>
                                    <th align="left" style={{paddingBottom: '8px'}}><Typography variant="caption" fontWeight={700}>Description</Typography></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><Typography variant="caption" sx={{fontFamily: 'monospace', bgcolor: 'rgba(255,255,255,0.05)', px: 0.5}}>+ - * / ( )</Typography></td>
                                    <td><Typography variant="caption">Standard arithmetic operations</Typography></td>
                                </tr>
                                <tr>
                                    <td><Typography variant="caption" sx={{fontFamily: 'monospace', bgcolor: 'rgba(255,255,255,0.05)', px: 0.5}}>MIN(a, b)</Typography></td>
                                    <td><Typography variant="caption">Returns the smallest value</Typography></td>
                                </tr>
                                <tr>
                                    <td><Typography variant="caption" sx={{fontFamily: 'monospace', bgcolor: 'rgba(255,255,255,0.05)', px: 0.5}}>MAX(a, b)</Typography></td>
                                    <td><Typography variant="caption">Returns the largest value</Typography></td>
                                </tr>
                                <tr>
                                    <td><Typography variant="caption" sx={{fontFamily: 'monospace', bgcolor: 'rgba(255,255,255,0.05)', px: 0.5}}>ROUND(n, d)</Typography></td>
                                    <td><Typography variant="caption">Rounds number n to d decimals</Typography></td>
                                </tr>
                                <tr>
                                    <td><Typography variant="caption" sx={{fontFamily: 'monospace', bgcolor: 'rgba(255,255,255,0.05)', px: 0.5}}>AVG(a, b...)</Typography></td>
                                    <td><Typography variant="caption">Calculates average of values</Typography></td>
                                </tr>
                                </tbody>
                            </table>
                        </Stack>
                    </Box>
                }
            >
                <Box sx={{ml: 0.5, display: 'flex', cursor: 'help', opacity: 0.7, '&:hover': {opacity: 1}}}>
                    <HelpOutline sx={{fontSize: 18}}/>
                </Box>
            </Tooltip>
        </>
    );
}

export default FormulaInputHelpTooltip;